<div class="back">
  <button mat-flat-button type="button"  color="accent" (click)="navigate()">
  <mat-icon>navigate_before</mat-icon>
  Torna indietro
</button>
</div>
<h1 class="title">DETTAGLIO OPERATORE:</h1>

<!-- <div class="title">
  <p>Nome:{{operator?.name | titlecase}} </p>
  <p>Cognome: {{operator?.surname | titlecase}}  </p> 
  <p>Email{{operator?.email}}</p>
  <p>Numero di telefono:{{operator?.phone}} </p> 
  <p><strong>Codice fiscale: </strong> </p>
</div> -->

<div class="operator-info">
  <ul>
    <li><strong>Nome:</strong> {{ operator?.name | titlecase }}</li>
    <li><strong>Cognome:</strong> {{ operator?.surname | titlecase }}</li>
    <li><strong>Email:</strong> {{ operator?.email }}</li>
    <li><strong>Numero di telefono:</strong> {{ operator?.phone }}</li>
    <!-- <li><strong>Codice fiscale:</strong> {{ operator?.taxCode }}</li> -->
  </ul>
</div>

<div class="add-button">
  <button mat-flat-button color="primary" (click)="addOperatorShift()">
    <mat-icon>add_circle_outline</mat-icon>
    Inserisci turno
  </button>
</div>



<!-- TABELLA -->
<div class="mat-elevation-z8 full-width">
  <table mat-table [dataSource]="dataSource">

    <!-- columns -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Data</th>
      <td mat-cell *matCellDef="let element"> {{ setDate(element.shiftDate)}} </td>
    </ng-container>

    <ng-container matColumnDef="startShift">
      <th mat-header-cell *matHeaderCellDef> Inizio turno </th>
      <td mat-cell *matCellDef="let element"> {{ formatTimeOnly(element.startTime) }} </td>
    </ng-container>

    <ng-container matColumnDef="endShift">
      <th mat-header-cell *matHeaderCellDef> Fine turno </th>
      <td mat-cell *matCellDef="let element"> {{ formatTimeOnly(element.endTime) }} </td>
    </ng-container>


    <!-- actions -->
    <ng-container matColumnDef="actions">
      <th class="action-th" mat-header-cell *matHeaderCellDef> Azioni </th>
      <td class="action-td" mat-cell *matCellDef="let element">
       
        <button mat-icon-button [disabled]="isPastDate(element.shiftDate)" (click)="editOperatorShift(element)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button [disabled]="isPastDate(element.shiftDate)"  (click)="deleteOperatorShift(element)"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- AGGIUNTO: riga mostrata se non ci sono dati -->
    <tr *matNoDataRow>
      <td [attr.colspan]="displayedColumns.length">
        <div class="no-data-wrapper">
          <mat-icon>info</mat-icon>
          <span>Nessun elemento.</span>
        </div>
      </td>
    </tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
  </mat-paginator>
</div>
